import { getGlobal } from '@/helpers'
// import {IS_DEV} from "@/constants";
import {compact} from "lodash";

export const FRAGMENTS_BREAKPOINT = 550
export const LAST_LOCATION = 'last_location'
export const LAST_SHARD_NAME = 'last_shard_name'

export const TEST_EMAILS = compact([
  'applereview@gameglass.gg',
  'windowstoretester@microsoft.com',
  // IS_DEV ? 'michel.boudreau@gameglass.gg' : undefined
])

export const GLOBAL = getGlobal()

export const SHARD_WIDTH = 215
export const SHARD_HEIGHT = 241
export const CONDENSED_SHARD_HEIGHT = 103
export const SHARD_GRID_GAP = 14

export const SUPPORT_URL = 'https://support.gameglass.gg'
